// Central configuration. Update links, images and contact details here.
export const SITE = {
  name: "Rooted Healing",
  tagline: "by Staci Freed",
  bookingUrl: "https://www.stacifreed.as.me/",
  social: {
    instagram: "https://www.instagram.com/official.rootedhealing",
    substack: "https://stacifreed.substack.com/",
    facebook: "", // final URL to be supplied
    youtube: "", // final URL to be supplied
  },
  contact: {
    email: "", // to be supplied
    note: "Consultations held online",
  },
  // Replaceable image slots. Swap these URLs when new photography arrives.
  images: {
    hero: "/images/staci-portrait.jpg",
    heroDetail:
      "https://images.unsplash.com/photo-1679212732499-05e8343b4f48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxzdW5saWdodCUyMGZvcmVzdCUyMGdyZWVuJTIwbGVhdmVzJTIwYm90YW5pY2FsJTIwZ2FyZGVuJTIwc2VyZW5lJTIwbmF0dXJlJTIwbGFuZHNjYXBlJTIwbWlzdHxlbnwwfHx8fDE3OTI0MjQ4MjZ8MA&ixlib=rb-4.1.0&q=85",
    staciPortrait: "/images/staci-river.jpg",
    finalBg: "/images/staci-light.jpg",
    pillarBody:
      "https://images.unsplash.com/photo-1598767140144-0e2991c18c68?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxib3RhbmljYWwlMjBuYXR1cmUlMjB3YXJtJTIwc3VubGlnaHQlMjBmb3Jlc3QlMjBncmVlbiUyMGZvbGlhZ2UlMjBsZWF2ZXMlMjBvcmdhbmljJTIwd2VsbG5lc3MlMjBwb3J0cmFpdCUyMGhhbmRzJTIwc2hhZG93fGVufDB8fHx8MTc5MjQyNDgxOHww&ixlib=rb-4.1.0&q=85",
    pillarMind:
      "https://images.pexels.com/photos/31310573/pexels-photo-31310573.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    pillarSpirit:
      "https://images.pexels.com/photos/33530530/pexels-photo-33530530.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tea: "https://images.pexels.com/photos/30074207/pexels-photo-30074207.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
};
